export default class MessageHandler {

    static showFailMessage(formId, id, showModal = true){
        let errorMessage = $("#" + id);
        if (errorMessage.length == 0) {
            errorMessage = $("#" + formId).find('[name=' + id + ']');
        }
        $('.show--error').removeClass('show--error');
        $(errorMessage).parent().addClass("show--error")
        try {
            if(showModal) this.showErrorModal(id)
        } catch (error) {
            
        }
    }

    static showErrorModal(id){
        const message =  document.getElementById(id).innerHTML
        const modal = document.getElementById('error-message-forms')
        const modalDescription = document.querySelector('#error-message-forms .description')

        modalDescription.innerHTML = message
        modal.classList.add("open-modal")
    }

    static removeAllFormFailMessages(selector = ".message-error-removed", elementClass = 'activate'){
        const inputGroup = document.querySelectorAll(selector);
        inputGroup.forEach(group => {
            group.classList.remove(elementClass);
        })
    }
}